// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__XjeUH","validationTips":"StatementDescriptor_validationTips__dERK_"};